<template>
    <v-dialog v-model="deactivateDialog" max-width="500" v-if="isSpaceAdmin && isActiveUser && showDeactivateActivateButton" persistent>
        <template v-slot:activator="{ on: dialog }">
            <template v-if="activatorType === 'listItem'">
                <v-list-item v-on="dialog">
                    <v-list-item-icon>
                        <v-icon color="error">mdi-account-off</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="error--text mr-5">Deactivate User</v-list-item-title>
                </v-list-item>
            </template>
            <v-tooltip v-else left>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn small color="error" text icon v-on="{ ...tooltip, ...dialog }">
                        <v-icon small>mdi-account-off</v-icon>
                    </v-btn>
                </template>
                <span>Deactivate User</span>
            </v-tooltip>
        </template>
        <v-card>
            <v-card-title class="d-flex align-center flex-nowrap align-start">
                User Deactivation
                <v-spacer></v-spacer>
                <v-btn :disabled="activationLoading" @click="deactivateDialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                Are you sure you want to deactivate the account of the user
                <span class="font-weight-bold">{{ userName }}</span>
                ?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn :loading="activationLoading" text color="error" @click="confirmDeactivate(uid)">deactivate</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { enumsData } from '@/mixins/enums'

export default {
    name: 'UserActionDeactivateDialog',
    mixins: [enumsData],
    props: {
        activatorType: {
            type: String,
            default: 'icon'
        },
        showDeactivateActivateButton: {
            type: Boolean,
            default: true
        },
        isActiveUser: Boolean,
        uid: String,
        userName: String,
        hierarchicalLevel: String
    },
    data() {
        return {
            deactivateDialog: false,
            activationLoading: false
        }
    },
    methods: {
        confirmDeactivate(userId) {
            this.activationLoading = true
            this.$store.dispatch('showSnackBar', {
                snackBarText: 'Deactivating user account, please wait....',
                snackBarTimeout: 10000,
                snackBarIcon: 'info'
            })

            this.$axios
                .put(`/users/${userId}/deactivate`)
                .then(() => {
                    this.$store.dispatch('showSnackBar', {
                        snackBarText: 'User account deactivated successfully',
                        snackBarTimeout: 5000,
                        snackBarIcon: 'check_circle'
                    })
                    this.$store.dispatch('orgStore/fetchOrgUsers', this.$route.params.oid)
                    if (this.hierarchicalLevel === this.nuvolosObjectTypes.SPACE || this.hierarchicalLevel === this.nuvolosObjectTypes.INSTANCE) {
                        this.$store.dispatch('spaceStore/fetchSpaceUsers', this.$route.params.sid)
                        this.$store.dispatch('instanceStore/fetchInstanceUsers', this.$route.params.iid)
                    }
                })
                .catch(() => {
                    this.$store.dispatch('showSnackBar', {
                        snackBarText: 'An error has occurred',
                        snackBarTimeout: 10000,
                        snackBarIcon: 'error'
                    })
                })
                .finally(() => {
                    this.activationLoading = false
                    this.deactivateDialog = false
                })
        }
    },
    computed: {
        ...mapGetters('spaceStore', ['isSpaceAdmin'])
    }
}
</script>
